import { Directive, HostBinding } from '@angular/core'
import { Platform } from '@ionic/angular/standalone'

@Directive({
  selector: '[slp-ionic-platform]',
})
export class PlatformClassDirective {

  private _elementClass: string[] = []

  @HostBinding('class')
  get elementClass(): string {
    return this._elementClass.join(' ')
  }
  constructor(public platform: Platform) {
    // this.platform.platforms()
    ['desktop']
      .map(s => 'platform-' + s)
      .forEach(s => {
        this._elementClass.push(s)
      })
  }
}
